/* eslint no-param-reassign: ["error", { "props": false }] */

import Constants from '../shared/constants';

function getCondition(props) {
  return props.condition || Constants.DEFAULT_CONDITION;
}

function emptyVal(val) {
  return val === null || val === undefined || val === '';
}

function removeEmptyParams(params) {
  Object.keys(params).forEach((prop) => {
    if (Array.isArray(params[prop])) {
      params[prop] = params[prop].filter((val) => !emptyVal(val));
      if (params[prop].length === 0) { delete params[prop]; }
    } else if (params[prop] && typeof params[prop] === 'object') {
      removeEmptyParams(params[prop]);
    } else if (emptyVal(params[prop])) {
      delete params[prop];
    }
  });
}

function handleItemRegion(params) {
  if (Array.isArray(params.item_region)) {
    const nonNullRegions = params.item_region.filter((val) => !emptyVal(val));
    params.item_region = nonNullRegions.pop();
  }
}

function handleShipsTo(params) {
  const code = params.ships_to || params.region;
  params.ships_to = code;
  delete params.region;
}

function removeDefaultPage(params) {
  if (params.page === Constants.DEFAULT_PAGE) {
    delete params.page;
  }
}

function buildSearchParams(props) {
  const params = { ...props, condition: getCondition(props) };

  if (params.featured_id) delete params.bumped;
  if (params.requestFacets) { params.facets = true; }
  delete params.requestFacets;

  if (params.shopSlug) {
    params.shop = params.shopSlug;
    delete params.shopSlug;
  }

  if (params.perPage) {
    params.per_page = params.perPage;
    delete params.perPage;
  }

  handleShipsTo(params);

  removeEmptyParams(params);
  removeDefaultPage(params);
  handleItemRegion(params);

  return params;
}

export default buildSearchParams;
